import { useVehicleForm } from '@/modules/vehicles/context/VehicleFormContext'
import { useLoadingStore, selectLoading } from '@/modules/shared/stores/loadingStore'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import * as React from 'react'

const AddVehicleFooter = () => {
  const { isReadyToSubmit, isEditState } = useVehicleForm()
  const loading = useLoadingStore(selectLoading)
  const { t } = useLocalize()

  return (
    <div className="tw-flex tw-justify-end tw-border-t tw-border-base-300">
      <button
        disabled={loading}
        type="submit"
        className={`tw-m-4 tw-rounded-lg tw-p-3 tw-text-sm tw-font-medium tw-text-content-base ${isReadyToSubmit ? 'tw-cursor-pointer tw-bg-primary tw-text-white' : 'tw-cursor-not-allowed tw-bg-gray-300 tw-text-gray-500'}`}
      >
        {isEditState ? t('vehicleBasics.save-vehicle') : t('vehicleBasics.new-vehicle')}
      </button>
    </div>
  )
}

export default AddVehicleFooter
